<template>
  <b-modal
    id="images-modal"
    size="xl"
    scrollable
    centered
    hide-footer
    header-class="lightbox-header"
    body-class="lightbox-body"
    content-class="lightbox-modal-content"
    lazy
  >
    <media-carousel :selectedImage="selectedImage" :imageList="imageList"></media-carousel>
  </b-modal>
</template>

<script>
/**
 * Area media modal component.
 *
 * This component contains all the interactions
 * for lightbox modal for area media.
 */
import MediaCarouselVue from './MediaCarousel';

export default {
  props: ['selectedImage', 'imageList'],
  components: {
    'media-carousel': MediaCarouselVue,
  },
};
</script>

<style>
  #images-modal___BV_modal_outer_ {
    z-index: 3000 !important;
  }
  #images-modal___BV_modal_backdrop_ {
    opacity: 1;
  }
</style>
